function setupStickyBar() {
  const stickyBar = document.querySelector('.free-shipping-bar-mobile-container');
  const target = document.querySelector('.pdp-payment-options');
  const footer = document.querySelector('#shopify-section-footer');

  if (!stickyBar || !target || !footer || window.innerWidth >= 990) return;

  const placeholder = document.createElement('div');
  placeholder.style.height = `${stickyBar.offsetHeight}px`;
  placeholder.style.display = 'none';
  stickyBar.parentNode.insertBefore(placeholder, stickyBar);

  let isFooterVisible = false;

  const toggleSticky = (isVisible) => {
    const shouldShowSticky = !isVisible && !isFooterVisible;
    stickyBar.classList.toggle('is-fixed', shouldShowSticky);
    placeholder.style.display = shouldShowSticky ? 'block' : 'none';
  };

  const observer = new IntersectionObserver(([entry]) => {
    toggleSticky(entry.isIntersecting);
  }, {
    root: null,
    threshold: 0.01,
  });

  observer.observe(target);

  const footerObserver = new IntersectionObserver(([entry]) => {
    isFooterVisible = entry.isIntersecting;
    toggleSticky(target.getBoundingClientRect().top < window.innerHeight);
  }, {
    root: null,
    threshold: 0.01,
  });

  footerObserver.observe(footer);

  const checkManual = () => {
    const rect = target.getBoundingClientRect();
    const footerRect = footer.getBoundingClientRect();
    isFooterVisible = footerRect.top < window.innerHeight && footerRect.bottom > 0;
    toggleSticky(rect.bottom > 0 && rect.top < window.innerHeight);
  };

  checkManual();
  window.addEventListener('scroll', checkManual, { passive: true });
  window.addEventListener('resize', checkManual);
  window.addEventListener('orientationchange', checkManual);
}

document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(() => {
    const sticky = document.querySelector('.free-shipping-bar-mobile-container');
    const target = document.querySelector('.pdp-payment-options');
    const footer = document.querySelector('#shopify-section-footer');
    if (sticky && target && footer) {
      observer.disconnect();
      setupStickyBar();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
